import React from "react";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import UserMappingsPanel from "../../shared/components/UserMappingsPanel";

const UserMappingsSection: React.FC = () => {
  const { stationId } = useParams<{ stationId: string }>();

  return (
    <>
      <Typography variant="h6" fontWeight="bold" marginBottom={1}>
        Bodycam User Mappings
      </Typography>
      <UserMappingsPanel stationId={stationId!} />
    </>
  );
};

export default UserMappingsSection;
